<template>
  <div>
    <div v-if="line1" class="has-text-grey">
      {{ line1 }}
    </div>
    <div v-if="line2">
      {{ line2 }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    line1() {
      const address = (this.value?.address || '').toString().trim()
      const floor = (this.value?.floor || '').toString().trim()
      const interior = (this.value?.interior || '').toString().trim()

      const parts = [
        address,
        floor ? `Piano ${floor}` : '',
        interior ? `Interno ${interior}` : ''
      ].filter(Boolean)

      return parts.join(', ')
    },

    line2() {
      const zip = (this.value?.zip || '').toString().trim()
      const city = (this.value?.city || '').toString().trim()
      const provinceRaw = (this.value?.province || '').toString().trim()
      const province = provinceRaw.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2)

      const base = [zip, city].filter(Boolean).join(' ')
      if (!base && !province) {
        return ''
      }

      if (province) {
        return (base ? base + ' ' : '') + '(' + province + ')'
      }

      return base
    }
  }
}
</script>
